import { memo } from 'react';
import AnimationPlayer from '../AnimationPlayer/AnimationPlayer';
import Box from '../Box/Box';
import Text from '../Text/Text';
import { EmptyStateProps } from './EmptyState.types';
import { Image } from '../..';

function EmptyState({
  animationSource,
  animationProps,
  imageName,
  imageProps,
  titleNS,
  titleKey,
  descriptionNS,
  descriptionKey,
  children,
  ...rest
}: EmptyStateProps) {
  return (
    <Box
      flex={1}
      flexDirection="column"
      alignContent="center"
      alignItems="center"
      gap="space-400"
      {...rest}
    >
      {imageName ? (
        <Image name={imageName} {...imageProps} />
      ) : animationSource ? (
        <AnimationPlayer source={animationSource} {...animationProps} />
      ) : null}
      <Text
        variant="h4"
        gradient="darkSurfaceAccent"
        textAlign="center"
        locNS={titleNS}
        locKey={titleKey}
      />
      <Text
        variant="body-l"
        color="darkSurfacePrimary"
        textAlign="center"
        locNS={descriptionNS}
        locKey={descriptionKey}
      />
      {children}
    </Box>
  );
}

export default memo(EmptyState);
